export const ERROR_GETTING_USER_INFO = "ERROR_GETTING_USER_INFO";
export const GETTING_USER_INFO = "GETTING_USER_INFO";
export const USER_PROFILE = "USER_PROFILE";
